import React from "react";
import { useState } from "react";

import imageOne from "../../../assets/1a Lisa.png";
import imageTwo from "../../../assets/Write sentences.png";

function LessonTwo() {
  const [q1, setQ1] = useState("");
  const [q2, setQ2] = useState("");
  const [q3, setQ3] = useState("");
  const [q4, setQ4] = useState("");
  const [q5, setQ5] = useState("");
  const [q6, setQ6] = useState("");
  const [q7, setQ7] = useState("");
  const [q8, setQ8] = useState("");
  const [q9, setQ9] = useState("");
  const [q10, setQ10] = useState("");
  const [q11, setQ11] = useState("");
  const [q12, setQ12] = useState("");
  const [q13, setQ13] = useState("");
  const [q14, setQ14] = useState("");
  const [q15, setQ15] = useState("");
  const [q16, setQ16] = useState("");
  const [q17, setQ17] = useState("");
  const [q18, setQ18] = useState("");
  const [q19, setQ19] = useState("");
  const [q20, setQ20] = useState("");
  const [q21, setQ21] = useState("");
  const [q22, setQ22] = useState("");
  const [q23, setQ23] = useState("");
  const [q24, setQ24] = useState("");
  const [q25, setQ25] = useState("");
  const [q26, setQ26] = useState("");
  const [q27, setQ27] = useState("");
  const [q28, setQ28] = useState("");
  const [q29, setQ29] = useState("");
  const [q30, setQ30] = useState("");
  const [q31, setQ31] = useState("");
  const [q32, setQ32] = useState("");
  const [q33, setQ33] = useState("");
  const [q34, setQ34] = useState("");
  const [q35, setQ35] = useState("");
  const [q36, setQ36] = useState("");
  const [q37, setQ37] = useState("");
  const [q38, setQ38] = useState("");
  const [q39, setQ39] = useState("");
  const [q40, setQ40] = useState("");
  return (
    <>
      <div className="row">
        <div className="task-one mb-3">
          <h4>
            <span>1a</span> Write the short form (she's / we aren't etc.)
          </h4>
          {/* <div>
            <audio controls autobuffer preload>
              <source src={audio16} type="audio/mp3" />
              <source src={audio16} type="audio/ogg" />
              <source src={audio16} type="audio/wav" />
              Your browser does not support the audio element.
            </audio>
          </div> */}
          <p>
            <ol>
              <li>
                she is
                <input
                  value="she's"
                  disabled
                  className="border"
                  type="text"
                  onChange={(e) => setQ1(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
              </li>
              <li>
                they are
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ2(e.target.value)}
                  style={{
                    background: q2.trim() === "they're" ? "#198754" : "white",
                    color: q2.trim() === "they're" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                it is not
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ3(e.target.value)}
                  style={{
                    background:
                      q3.trim() === "it's not"
                        ? "#198754"
                        : q3.trim() === "it isn't"
                        ? "#198754"
                        : "white",
                    color:
                      q3.trim() === "it's not"
                        ? "white"
                        : q3.trim() === "it isn't"
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                that is
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ4(e.target.value)}
                  style={{
                    background: q4.trim() === "that's" ? "#198754" : "white",
                    color: q4.trim() === "that's" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                I am not
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ5(e.target.value)}
                  style={{
                    background: q5.trim() === "I'm not" ? "#198754" : "white",
                    color: q5.trim() === "I'm not" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                you are not
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ6(e.target.value)}
                  style={{
                    background:
                      q6.trim() === "you're not"
                        ? "#198754"
                        : q6.trim() === "you aren't"
                        ? "#198754"
                        : "white",
                    color:
                      q6.trim() === "you're not"
                        ? "white"
                        : q6.trim() === "you aren't"
                        ? "white"
                        : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-two mb-3">
          <h4>
            <span>2a</span> Write{" "}
            <span>
              <strong>am, is </strong>or <strong>are.</strong>
            </span>
          </h4>
          <p>
            <ol>
              <li>
                The weather
                <input
                  value="is"
                  disabled
                  className="border"
                  type="text"
                  onChange={(e) => setQ7(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                nice today.
              </li>
              <li>
                I
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ8(e.target.value)}
                  style={{
                    background: q8.trim() === "am" ? "#198754" : "white",
                    color: q8.trim() === "am" ? "white" : "black",
                  }}
                />{" "}
                not rich.
              </li>
              <li>
                This bag
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ9(e.target.value)}
                  style={{
                    background: q9.trim() === "is" ? "#198754" : "white",
                    color: q9.trim() === "is" ? "white" : "black",
                  }}
                />
                heavy.
              </li>
              <li>
                These bags
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ10(e.target.value)}
                  style={{
                    background: q10.trim() === "are" ? "#198754" : "white",
                    color: q10.trim() === "are" ? "white" : "black",
                  }}
                />{" "}
                heavy.
              </li>
              <li>
                Look! There
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ11(e.target.value)}
                  style={{
                    background: q11.trim() === "is" ? "#198754" : "white",
                    color: q11.trim() === "is" ? "white" : "black",
                  }}
                />
                Helen
              </li>
              <li>
                My brother and I
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ12(e.target.value)}
                  style={{
                    background: q12.trim() === "are" ? "#198754" : "white",
                    color: q12.trim() === "are" ? "white" : "black",
                  }}
                />{" "}
                good tennis players.
              </li>
              <li>
                Emily
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ13(e.target.value)}
                  style={{
                    background: q13.trim() === "is" ? "#198754" : "white",
                    color: q13.trim() === "is" ? "white" : "black",
                  }}
                />
                at home. Her children
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ14(e.target.value)}
                  style={{
                    background: q14.trim() === "are" ? "#198754" : "white",
                    color: q14.trim() === "are" ? "white" : "black",
                  }}
                />{" "}
                at school.
              </li>
              <li>
                I
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ15(e.target.value)}
                  style={{
                    background: q15.trim() === "am" ? "#198754" : "white",
                    color: q15.trim() === "am" ? "white" : "black",
                  }}
                />
                a taxi driver. My sister
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ16(e.target.value)}
                  style={{
                    background: q16.trim() === "is" ? "#198754" : "white",
                    color: q16.trim() === "is" ? "white" : "black",
                  }}
                />
                a nurse.
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-three mb-3">
          <h4>
            <span>3a</span> Complete the sentences.
          </h4>
          <p>
            <ol>
              <li>
                Steve is ill.
                <input
                  value="He is"
                  disabled
                  className="border"
                  type="text"
                  onChange={(e) => setQ17(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                in bed.
              </li>
              <li>
                I am not hungry, but
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ18(e.target.value)}
                  style={{
                    background:
                      q18.trim() === "I'm"
                        ? "#198754"
                        : q18.trim() === "I am"
                        ? "#198754"
                        : "white",
                    color:
                      q18.trim() === "I'm"
                        ? "white"
                        : q18.trim() === "I am"
                        ? "white"
                        : "black",
                  }}
                />
                thirsty.
              </li>
              <li>
                Mr Thomas is a very old man.
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ19(e.target.value)}
                  style={{
                    background:
                      q19.trim() === "He is"
                        ? "#198754"
                        : q19.trim() === "He's"
                        ? "#198754"
                        : "white",
                    color:
                      q19.trim() === "He is"
                        ? "white"
                        : q19.trim() === "He's"
                        ? "white"
                        : "black",
                  }}
                />
                98.
              </li>
              <li>
                These chairs aren't beautiful, but
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ20(e.target.value)}
                  style={{
                    background:
                      q20.trim() === "they are"
                        ? "#198754"
                        : q20.trim() === "they're"
                        ? "#198754"
                        : "white",
                    color:
                      q20.trim() === "they are"
                        ? "white"
                        : q20.trim() === "they're"
                        ? "white"
                        : "black",
                  }}
                />
                comfortable.
              </li>
              <li>
                The weather is nice today.
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ21(e.target.value)}
                  style={{
                    background:
                      q21.trim() === "It is"
                        ? "#198754"
                        : q21.trim() === "It's"
                        ? "#198754"
                        : "white",
                    color:
                      q21.trim() === "It is"
                        ? "white"
                        : q21.trim() === "It's"
                        ? "white"
                        : "black",
                  }}
                />
                warm and sunny.
              </li>
              <li>
                '
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ22(e.target.value)}
                  style={{
                    background:
                      q22.trim() === "You are"
                        ? "#198754"
                        : q22.trim() === "You're"
                        ? "#198754"
                        : "white",
                    color:
                      q22.trim() === "You are"
                        ? "white"
                        : q22.trim() === "You're"
                        ? "white"
                        : "black",
                  }}
                />
                late.' 'No, I'm not. I'm early!'
              </li>
              <li>
                Catherine isn't at home.
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ23(e.target.value)}
                  style={{
                    background:
                      q23.trim() === "She is"
                        ? "#198754"
                        : q23.trim() === "She's"
                        ? "#198754"
                        : "white",
                    color:
                      q23.trim() === "She is"
                        ? "white"
                        : q23.trim() === "She's"
                        ? "white"
                        : "black",
                  }}
                />
                at work.
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ24(e.target.value)}
                  style={{
                    background: q24.trim() === "Is this" ? "#198754" : "white",
                    color: q24.trim() === "Is this" ? "white" : "black",
                  }}
                />
                "Oh, thank you very much."
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-four mb-3">
          <div>
            <img
              src={imageOne}
              alt="Lisa's sentences"
              className=""
              width="100%"
            />
          </div>
          <h4>
            <span>4a</span> Look at Lisa's sentences in the photo above. Now
            write sentences about yourself.
          </h4>
          <p>
            <ol>
              <li>
                (name?) My
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ25(e.target.value)}
                />
                .
              </li>
              <li>
                (age?) I
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ26(e.target.value)}
                />
                .
              </li>
              <li>
                (from?) I
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ27(e.target.value)}
                />
                .
              </li>
              <li>
                (job?) I
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ28(e.target.value)}
                />
                .
              </li>
              <li>
                (favourite colour or colours?) My
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ29(e.target.value)}
                />
                .
              </li>
              <li>
                (interested in ...?) I
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ30(e.target.value)}
                />
                .
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-five mb-3">
          <div>
            <img
              src={imageTwo}
              alt="Pictures for different actions"
              className=""
              width="100%"
            />
          </div>
          <h4>
            <span>5a</span>
            Write sentences for the pictures. Use:
          </h4>
          <p>
            <ol>
              <li>
                <input
                  disabled
                  value="She's thirsty"
                  className="border"
                  type="text"
                  onChange={(e) => setQ25(e.target.value)}
                  style={{ background: "#198754", color: "white" }}
                />
                .
              </li>
              <li>
                They
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ26(e.target.value)}
                  style={{
                    background:
                      q26.trim() === "are cold"
                        ? "#198754"
                        : q26.trim() === "'re cold"
                        ? "#198754"
                        : "white",
                    color:
                      q26.trim() === "are cold"
                        ? "white"
                        : q26.trim() === "'re cold"
                        ? "white"
                        : "black",
                  }}
                />
                .
              </li>
              <li>
                He
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ27(e.target.value)}
                  style={{
                    background:
                      q27.trim() === "is hot"
                        ? "#198754"
                        : q27.trim() === "'s hot"
                        ? "#198754"
                        : "white",
                    color:
                      q27.trim() === "is hot"
                        ? "white"
                        : q27.trim() === "'s hot"
                        ? "white"
                        : "black",
                  }}
                />
                .
              </li>
              <li>
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ28(e.target.value)}
                  style={{
                    background:
                      q28.trim() === "He is scared"
                        ? "#198754"
                        : q28.trim() === "'s scared"
                        ? "#198754"
                        : "white",
                    color:
                      q28.trim() === "He is scared"
                        ? "white"
                        : q28.trim() === "'s scared"
                        ? "white"
                        : "black",
                  }}
                />
                .
              </li>
              <li>
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ29(e.target.value)}
                  style={{
                    background:
                      q29.trim() === "They are hungry"
                        ? "#198754"
                        : q29.trim() === "They're hungry"
                        ? "#198754"
                        : "white",
                    color:
                      q29.trim() === "They are hungry"
                        ? "white"
                        : q29.trim() === "They're hungry"
                        ? "white"
                        : "black",
                  }}
                />
                .
              </li>
              <li>
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ30(e.target.value)}
                  style={{
                    background:
                      q30.trim() === "She is angry"
                        ? "#198754"
                        : q30.trim() === "She's angry"
                        ? "#198754"
                        : "white",
                    color:
                      q30.trim() === "She is angry"
                        ? "white"
                        : q30.trim() === "She's angry"
                        ? "white"
                        : "black",
                  }}
                />
                .
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-six mb-3">
          <h4>
            <span>6a</span> Write true sentences, positive or negative. Use
            <span>
              <strong> is/isn't</strong> or <strong> are/aren't.</strong>
            </span>
          </h4>
          <p>
            <ol>
              <li>
                (it / hot today)
                <input
                  value="it isn't hot today."
                  disabled
                  className="border"
                  type="text"
                  onChange={(e) => setQ31(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                or
                <input
                  value="it's hot today."
                  disabled
                  className="border"
                  type="text"
                  onChange={(e) => setQ31(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                .
              </li>
              <li>
                (it / windy today) It
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ32(e.target.value)}
                  style={{
                    background:
                      q32.trim() === "is windy today."
                        ? "#198754"
                        : q32.trim() === "'s windy today."
                        ? "#198754"
                        : q32.trim() === "is not windy today."
                        ? "#198754"
                        : q32.trim() === "isn't windy today."
                        ? "#198754"
                        : q32.trim() === "'s not windy today."
                        ? "#198754"
                        : "white",
                    color:
                      q32.trim() === "is windy today."
                        ? "white"
                        : q32.trim() === "'s windy today."
                        ? "white"
                        : q32.trim() === "is not windy today."
                        ? "white"
                        : q32.trim() === "isn't windy today."
                        ? "white"
                        : q32.trim() === "'s not windy today."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (my hands / cold) My
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ33(e.target.value)}
                  style={{
                    background:
                      q33.trim() === "hands are cold."
                        ? "#198754"
                        : q33.trim() === "hands are not cold."
                        ? "#198754"
                        : q33.trim() === "hands aren't cold."
                        ? "#198754"
                        : "white",
                    color:
                      q33.trim() === "hands are cold."
                        ? "white"
                        : q33.trim() === "hands are not cold."
                        ? "white"
                        : q33.trim() === "hands aren't cold."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (Brazil / a very big country)
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ34(e.target.value)}
                  style={{
                    background:
                      q34.trim() === "Brazil is a very big country."
                        ? "#198754"
                        : q34.trim() === "Brazil's a very big country."
                        ? "#198754"
                        : q34.trim() === "Brazil is not a very big country."
                        ? "#198754"
                        : q34.trim() === "Brazil's not a very big country."
                        ? "#198754"
                        : q34.trim() === "Brazil isn't a very big country."
                        ? "#198754"
                        : "white",
                    color:
                      q34.trim() === "Brazil is a very big country."
                        ? "white"
                        : q34.trim() === "Brazil's a very big country."
                        ? "white"
                        : q34.trim() === "Brazil is not a very big country."
                        ? "white"
                        : q34.trim() === "Brazil's not a very big country."
                        ? "white"
                        : q34.trim() === "Brazil isn't a very big country."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (diamonds / cheap)
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ35(e.target.value)}
                  style={{
                    background:
                      q35.trim() === "Diamonds are not cheap."
                        ? "#198754"
                        : q35.trim() === "Diamonds aren't cheap."
                        ? "#198754"
                        : "white",
                    color:
                      q35.trim() === "Diamonds are not cheap."
                        ? "white"
                        : q35.trim() === "Diamonds aren't cheap."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (Al Haj Yousif / in Sudan)
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ36(e.target.value)}
                  style={{
                    background:
                      q36.trim() === "Al Haj Yousif is in Sudan."
                        ? "#198754"
                        : q36.trim() === "Al Haj Yousif's in Sudan"
                        ? "#198754"
                        : "white",
                    color:
                      q36.trim() === "Al Haj Yousif is in Sudan."
                        ? "white"
                        : q36.trim() === "Al Haj Yousif's in Sudan"
                        ? "white"
                        : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-seven mb-3">
          <h4>
            <span>7a</span> Write true sentences, positive or negative. Use
            <span>
              <strong> I'm / I'm not</strong>
            </span>
          </h4>
          <p>
            <ol>
              <li>
                (tired)
                <input
                  value="I'm tired."
                  disabled
                  className="border"
                  type="text"
                  onChange={(e) => setQ37(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                or
                <input
                  value="I'm not tired."
                  disabled
                  className="border"
                  type="text"
                  onChange={(e) => setQ37(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                .
              </li>
              <li>
                (hungry) I
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ38(e.target.value)}
                  style={{
                    background:
                      q32.trim() === "am hungry."
                        ? "#198754"
                        : q38.trim() === "'m hungry."
                        ? "#198754"
                        : q38.trim() === "am not hungry."
                        ? "#198754"
                        : q38.trim() === "'m not hungry."
                        ? "#198754"
                        : "white",
                    color:
                      q38.trim() === "am hungry."
                        ? "white"
                        : q38.trim() === "'m hungry."
                        ? "white"
                        : q38.trim() === " am not hungry."
                        ? "white"
                        : q38.trim() === "'m not hungry"
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (a good swimmer)
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ39(e.target.value)}
                  style={{
                    background:
                      q39.trim() === "I am a good swimmer."
                        ? "#198754"
                        : q39.trim() === "I'm a good swimmer."
                        ? "#198754"
                        : q39.trim() === "I am not a good swimmer."
                        ? "#198754" : q39.trim() === "I'm not a good swimmer." ? "#198754"
                        : "white",
                    color:
                      q39.trim() === "I am a good swimmer."
                        ? "white"
                        : q39.trim() === "I'm a good swimmer."
                        ? "white"
                        : q39.trim() === "I am not a good swimmer."
                        ? "white" : q39.trim() === "I'm not a good swimmer." ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (intrested in football)
                <input
                  className="border"
                  type="text"
                  onChange={(e) => setQ40(e.target.value)}
                  style={{
                    background:
                      q40.trim() === "I am interested in football."
                        ? "#198754"
                        : q40.trim() === "I'm interested in football."
                        ? "#198754"
                        : q40.trim() === "I am not interested in football."
                        ? "#198754"
                        : q40.trim() === "I'm not interested in football."
                        ? "#198754"
                        : "white",
                    color:
                      q40.trim() === "I am interested in football."
                        ? "white"
                        : q40.trim() === "I'm interested in football."
                        ? "white"
                        : q40.trim() === "I am not interested in football."
                        ? "white"
                        : q40.trim() === "I'm not interested in football."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>
      </div>
    </>
  );
}

export default LessonTwo;
